/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetTenantsOptions,
  GetTenantsStatus200,
  GetTenantsStatus400,
  GetTenantsStatus500,
} from '../types/GetTenants'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getTenants } from '../clients/getTenants'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTenantsQueryKey = ({ query }: Omit<GetTenantsOptions, 'headers'> = {}) =>
  [{ url: '/v1/tenants' }, ...(query ? [query] : [])] as const

type GetTenantsQueryKey = ReturnType<typeof getTenantsQueryKey>

export function getTenantsQueryOptions(
  { query }: GetTenantsOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getTenantsQueryKey({ query })
  return queryOptions<
    GetTenantsStatus200,
    ResponseErrorConfig<GetTenantsStatus400 | GetTenantsStatus500>,
    GetTenantsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTenants({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get tenants
 * {@link /v1/tenants}
 */
export function useGetTenants<
  TData = GetTenantsStatus200,
  TQueryData = GetTenantsStatus200,
  TQueryKey extends QueryKey = GetTenantsQueryKey,
>(
  { query }: { query?: GetTenantsOptions['query'] | (() => GetTenantsOptions['query']) } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTenantsStatus200,
        ResponseErrorConfig<GetTenantsStatus400 | GetTenantsStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getTenantsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getTenantsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetTenantsStatus400 | GetTenantsStatus500>> & {
    queryKey: TQueryKey
  }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
